import { matrix } from './matrix.js'

export const update = dt => {
	matrix.update()
}